import React, { useState } from "react";

function Square({ index, value, player1, onSquareClick, isWinningSquare }) {
    const [isBlinking, setIsBlinking] = useState(false);
    const [isEmpty, setIsEmpty] = useState(false);
    const indexOpacity = 0.05;
    const blinkOpacity = 0.2;
    const delay = 1000;
    const blinkDuration = `500ms`;

    document.documentElement.style.setProperty("--blink-opacity", blinkOpacity);
    document.documentElement.style.setProperty(
        "--blink-duration",
        blinkDuration
    );

    const handleSquareClick = () => {
        if (value == null) {
            setIsEmpty(true);
        } else {
            setIsEmpty(false);
        }
        onSquareClick();
        setIsBlinking(true);
        setTimeout(() => {
            setIsBlinking(false);
        }, delay);
    };

    // define your classes for players
    const p1SquareClass = "p1-square";
    const p2SquareClass = "p2-square";

    // Otherwise, if winning class
    const winningColor = isWinningSquare ? "winningSquare" : "";

    let blinkingColor = "";
    if (isBlinking) {
        blinkingColor = isEmpty ? "blink-black" : "blink-red";
    }

    let playerColor = "";

    if (value !== null) {
        playerColor = value == player1 ? p1SquareClass : p2SquareClass;
    }

    const buttonClass = `square ${playerColor} ${blinkingColor} ${winningColor}`;

    return (
        <div>
            <button className={buttonClass} onClick={handleSquareClick}>
                {value == null ? (
                    <span
                        className="square-text"
                        style={{ opacity: indexOpacity }}
                    >
                        {index}
                    </span>
                ) : (
                    <span className="square-text" style={{ opacity: 1 }}>
                        {value}
                    </span>
                )}
            </button>
        </div>
    );
}

function Board({
    p1,
    specified_rows,
    specified_cols,
    onSquareClick,
    squares,
    winningIndices,
}) {
    let rows = [];
    for (let row_ind = 0; row_ind < specified_rows; row_ind++) {
        let row = [];
        for (let col_ind = 0; col_ind < specified_cols; col_ind++) {
            let i = row_ind * specified_cols + col_ind;
            row.push(
                <Square
                    index={i + 1}
                    value={squares[i]}
                    key={i}
                    player1={p1}
                    onSquareClick={() => onSquareClick(i)}
                    isWinningSquare={winningIndices.includes(i)}
                />
            );
        }
        rows.push(
            <div className="board-row" key={row_ind}>
                {row}
            </div>
        );
    }

    return <div>{rows}</div>;
}

export default Board;
